import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Badge, IconButton, Tooltip } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
import { getUnreadCount } from '../../../packages/notifications/store/notificationActions';

// How often the badge re-checks. The API has no push channel to the browser,
// so the bell polls; a minute keeps it current without hammering the server.
const POLL_MS = 60 * 1000;

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const dispatch = useDispatch();
  const { totalUnRead } = useSelector((state) => state.notificationReducer);

  useEffect(() => {
    dispatch(getUnreadCount());
    const timer = setInterval(() => {
      // Skip hidden tabs; the count refreshes when the user comes back.
      if (!document.hidden) dispatch(getUnreadCount());
    }, POLL_MS);
    const onVisible = () => {
      if (!document.hidden) dispatch(getUnreadCount());
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [dispatch]);

  return (
    <Tooltip title="Notifications">
      <IconButton component={RouterLink} to="/dashboard/notifications" color="default" sx={{ width: 40, height: 40 }}>
        <Badge badgeContent={totalUnRead} color="error">
          <Iconify icon="eva:bell-fill" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
